import { CompaniesService } from "./implementations/companies.service";

export default defineNuxtPlugin((nuxtApp) => {
  const companies = new CompaniesService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
        companies: companies,
    },
  };
});